import { useAdaChatContext } from '../../contexts/AdaChatContext';

const AdaChatToolEnabled = ({ children }) => {
    const isSupportChatEnabled = useAdaChatContext();
    return children({ isLoading: false, isEnabled: isSupportChatEnabled });
};

export default AdaChatToolEnabled;
